/// <amd-module name="Wit/WorkItemWikiLinks/WikiUtils" />
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";

const wikiPageUriPattern = /^vstfs:\/\/\/Wiki\/WikiPage\/(?<projectId>[a-z0-9\-]+)\/(?<wikiId>[a-z0-9\-]+)\/(?<pagePath>.*)$/i;
interface WikiPageUriCaptureGroups {
    groups: IWikiPageInfo;
}
export interface IWikiPageInfo {
    projectId: string;
    wikiId: string;
    pagePath: string;
}

/**
 *
 * e.g. vstfs:///Wiki/WikiPage/1a976920-8cd1-499f-a45c-07b3b1d2e2b5%2Fb7180cbb-6fe2-44d3-8f88-f8911fbd8288%2FFirst%20Wiki%20Page%2FPage%203%2FPage%204
 * decoded: vstfs:///Wiki/WikiPage/1a976920-8cd1-499f-a45c-07b3b1d2e2b5/b7180cbb-6fe2-44d3-8f88-f8911fbd8288/First Wiki Page/Page 3/Page 4
 * @param pageFilePath
 */
export function getWikiPageInfo(pageFilePath: string): IWikiPageInfo | undefined {
    const decodedPath = decodeURIComponent(pageFilePath);
    const match = wikiPageUriPattern.exec(decodedPath) as (RegExpExecArray & WikiPageUriCaptureGroups) | null;
    if (match === null) {
        return undefined;
    }

    return match.groups;
}

export function getPageName(page: WikiPage): string {
    let pathWithoutTrailingSlash = page.path;
    while (pathWithoutTrailingSlash.endsWith("/")) {
        pathWithoutTrailingSlash = pathWithoutTrailingSlash.substring(0, pathWithoutTrailingSlash.length - 1);
    }

    const slashIndex = pathWithoutTrailingSlash.lastIndexOf("/");
    if (slashIndex === -1) {
        return pathWithoutTrailingSlash;
    }

    return pathWithoutTrailingSlash.substring(slashIndex + 1)
}

export function stripLeadingSlashes(path: string) {
    while (path.startsWith("/")) {
        path = path.substring(1);
    }
    return path;
}
